import { isNotNullOrUndef } from '../js/helpers/isNotNullOrUndef';
import { dispatchGAEvent } from './dispatchGAEvent';
let previousElement = null;
const handler = (dataAttr, bubbles = false) => {
    return (event) => {
        try {
            if (!isNotNullOrUndef(event.target) ||
                !(event.target instanceof Element))
                return;
            const target = event.target.closest(`[${dataAttr}]`);
            if (!isNotNullOrUndef(target))
                return;
            if (!bubbles && isNotNullOrUndef(previousElement) && previousElement.contains(target)) {
                return;
            }
            else {
                previousElement = target;
            }
            const dataValue = target.getAttribute(dataAttr);
            if (!isNotNullOrUndef(dataValue) ||
                !dataValue.startsWith('['))
                return;
            const events = JSON.parse(dataValue);
            if (!(events[0] instanceof Array) &&
                !(events[1] instanceof Array) &&
                !(events[2] instanceof Array)) {
                const [category, action, label] = events;
                dispatchGAEvent(category, action, label);
            }
            else {
                events.forEach((params) => {
                    if (params instanceof Array) {
                        const [category, action, label] = params;
                        dispatchGAEvent(category, action, label);
                    }
                });
            }
        }
        catch (e) {
            console.log('GA event error: ', e);
        }
    };
};
const clickEventHandler = handler('data-ga-event', true);
document.body.addEventListener('click', clickEventHandler);
